export default __webpack_public_path__ + "static/media/Char4.8128a570.png";